<template>
  <div class="mx-auto px-6 py-8 pt-[100px] w-full max-w-[1000px]">
    <h1 class="text-3xl font-semibold mb-10">Paramètres</h1>
    <v-form ref="form" class="space-y-6">
      <div class="flex items-center mb-2">
        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
          />
        </svg>
        <label class="text-xl block font-semibold">Information du compte</label>
      </div>
      <div class="grid md:grid-cols-3 gap-4">
        <label class="text-lg block text-[#c7cef8]">Pseudo : <span class="text-md font-semibold">Seb</span></label>
        <label class="text-lg block text-[#c7cef8]"
          >Email : <span class="text-md font-semibold">test@test.fr</span></label
        >
        <span></span>

        <v-date-input
          prepend-icon=""
          prepend-inner-icon="$calendar"
          clearable
          label="Date de naissance"
          v-model="dob"
          @update:modelValue="dobUpdate()"
        ></v-date-input>
        <v-select
          v-model="gender"
          prepend-inner-icon="mdi-gender-male-female"
          :items="genders"
          label="Sexe"
          outlined
          dense
          @update:modelValue="dobUpdate()"
        />
        <v-select
          @update:modelValue="dobUpdate()"
          prepend-inner-icon="mdi-web"
          v-model="country"
          :items="countries"
          label="Pays"
          outlined
          dense
        />
      </div>
      <div class="grid md:grid-cols-3 gap-4">
        <div class="mb-4">
          <v-btn prepend-icon="mdi-account" @click="editingPseudo = !editingPseudo" small class="bg-linear text-white">
            {{ editingPseudo ? "Annuler" : "Modifier mon pseudo" }}
          </v-btn>
          <v-expand-transition>
            <div v-if="editingPseudo" class="mt-3 space-y-3">
              <v-text-field v-model="newPseudo" label="Nouveau pseudo" :rules="[v => !!v || 'Requis']" outlined dense />
              <v-text-field
                v-model="pwdForPseudo"
                label="Mot de passe actuel"
                type="password"
                :rules="[v => !!v || 'Requis']"
                outlined
                dense
              />
              <v-btn @click="savePseudo" class="bg-linear text-white">Valider</v-btn>
            </div>
          </v-expand-transition>
        </div>

        <!-- Email -->
        <div class="mb-4">
          <v-btn prepend-icon="mdi-email" @click="editingEmail = !editingEmail" small class="bg-linear text-white">
            {{ editingEmail ? "Annuler" : "Modifier mon email" }}
          </v-btn>
          <v-expand-transition>
            <div v-if="editingEmail" class="mt-3 space-y-3">
              <v-text-field
                v-model="newEmail"
                label="Nouvel email"
                type="email"
                :rules="[v => /.+@.+\..+/.test(v) || 'Email invalide']"
                outlined
                dense
              />
              <v-text-field
                v-model="pwdForEmail"
                label="Mot de passe actuel"
                type="password"
                :rules="[v => !!v || 'Requis']"
                outlined
                dense
              />
              <v-btn @click="saveEmail" class="bg-linear text-white">Valider</v-btn>
            </div>
          </v-expand-transition>
        </div>
        <div class="mb-4">
          <v-btn prepend-icon="mdi-lock" @click="editingMdp = !editingMdp" small class="bg-linear text-white">
            {{ editingMdp ? "Annuler" : "Modifier mon mot de passe" }}
          </v-btn>
          <v-expand-transition>
            <div v-if="editingMdp" class="mt-3 space-y-3">
              <v-text-field
                v-model="pwdForMdp"
                label="Mot de passe actuel"
                type="password"
                :rules="[v => !!v || 'Requis']"
                outlined
                dense
              />
              <v-text-field
                v-model="newMdp"
                label="Nouveau mot de passe"
                :rules="[v => !!v || 'Requis']"
                outlined
                dense
              />
              <v-text-field
                v-model="confirmMdp"
                label="Confirmer le mot de passe"
                :rules="[v => v === newMdp || 'Ne correspond pas']"
                outlined
                dense
              />

              <v-btn @click="saveMdp" class="bg-linear text-white">Valider</v-btn>
            </div>
          </v-expand-transition>
        </div>
      </div>

      <!-- Visibilité de la liste d’animes -->
      <div>
        <div class="flex items-center mb-2">
          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M8.5 11.5h7v-1h-7zm0-4h7v-1h-7zm10.412 12.437l-3.416-4.43q-.367-.478-.877-.742q-.51-.265-1.119-.265H5V4.616q0-.691.463-1.153T6.616 3h10.769q.69 0 1.153.463T19 4.616v14.769q0 .144-.022.285q-.022.142-.066.267M6.616 21q-.691 0-1.153-.462T5 19.385V15.5h8.5q.366 0 .674.16q.309.161.536.457l3.527 4.616q-.183.127-.397.197t-.456.07z"
            />
          </svg>
          <label class="text-xl block font-semibold">Visibilité de ma liste d’animes</label>
        </div>
        <v-radio-group v-model="animePrivacy" row>
          <v-radio label="Public" value="public" />
          <v-radio label="Privé (sauf amis)" value="friends" />
          <v-radio label="Privé" value="private" />
        </v-radio-group>
      </div>

      <!-- Import MyAnimeList -->
      <div class="flex items-center mb-2">
        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16">
          <!-- Icon from Gitlab SVGs by GitLab B.V. - https://gitlab.com/gitlab-org/gitlab-svgs/-/blob/main/LICENSE -->
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M11.78 7.159a.75.75 0 0 0-1.06 0l-1.97 1.97V1.75a.75.75 0 0 0-1.5 0v7.379l-1.97-1.97a.75.75 0 0 0-1.06 1.06l3.25 3.25L8 12l.53-.53l3.25-3.25a.75.75 0 0 0 0-1.061M2.5 9.75a.75.75 0 1 0-1.5 0V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9.75a.75.75 0 0 0-1.5 0V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"
            clip-rule="evenodd"
          />
        </svg>
        <label class="text-xl block font-semibold">Importer ma liste de MyAnimeList </label>
      </div>
      <div class="flex items-center space-x-4">
        <v-text-field v-model="malUsername" label="Pseudo MyAnimeList*" outlined dense />
        <v-btn @click="importMAL" :disabled="!malUsername" class="bg-linear text-white">Importer</v-btn>
      </div>
      <span class="relative top-[-14px]">*La liste doit être en public</span>

      <!-- Filtres de chansons -->
      <div>
        <div class="flex items-center mb-2">
          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
            <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
            <path
              fill="currentColor"
              d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5"
            />
          </svg>
          <label class="text-xl block font-semibold">Listes sélectionnées en partie personnalisé </label>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-2">
          <v-checkbox v-model="filters.enCours" label="En cours" />
          <v-checkbox v-model="filters.aVoir" label="À voir" />
          <v-checkbox v-model="filters.termine" label="Terminé" />
          <v-checkbox v-model="filters.enPause" label="En pause" />
          <v-checkbox v-model="filters.abandonne" label="Abandonné" />
          <v-checkbox v-model="filters.fav" label="Favoris" />
        </div>
      </div>
      <!-- Bouton NSFW (>=18ans) -->
      <div>
        <div class="flex items-center mb-2">
          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
            <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
            <path
              fill="currentColor"
              d="M10 20q-.825 0-1.412-.587T8 18t.588-1.412T10 16h10q.825 0 1.413.588T22 18t-.587 1.413T20 20zm0-6q-.825 0-1.412-.587T8 12t.588-1.412T10 10h10q.825 0 1.413.588T22 12t-.587 1.413T20 14zm0-6q-.825 0-1.412-.587T8 6t.588-1.412T10 4h10q.825 0 1.413.588T22 6t-.587 1.413T20 8zM4 8q-.825 0-1.412-.587T2 6t.588-1.412T4 4t1.413.588T6 6t-.587 1.413T4 8m0 6q-.825 0-1.412-.587T2 12t.588-1.412T4 10t1.413.588T6 12t-.587 1.413T4 14m0 6q-.825 0-1.412-.587T2 18t.588-1.412T4 16t1.413.588T6 18t-.587 1.413T4 20"
            />
          </svg>
          <label class="text-xl block font-semibold">Animes visibles </label>
        </div>
        <div class="flex justify-between items-center pt-6 flex-wrap">
          <v-switch v-model="showKids" label="Afficher les animes pour enfants" hide-details></v-switch>
          <v-switch v-model="showNSFW" @change="toggleNSFW" label="Afficher les hentai" hide-details></v-switch>
        </div>
      </div>
      <div>
        <div class="flex items-center mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16">
            <!-- Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE -->
            <path
              fill="currentColor"
              d="M2.466 1.45c.637-1.266 2.431-1.266 3.068 0l1.779 3.536C7.889 6.131 7.069 7.5 5.779 7.5H2.22C.931 7.5.111 6.13.687 4.986zM9 2.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm2.495 6.331a1 1 0 0 1 1 0l1.99 1.15a1 1 0 0 1 .5.865v2.298a1 1 0 0 1-.5.866l-1.99 1.149a1 1 0 0 1-1 0l-1.99-1.15a1 1 0 0 1-.5-.865v-2.298a1 1 0 0 1 .5-.866zM1 12a3 3 0 1 1 6 0a3 3 0 0 1-6 0"
            />
          </svg>
          <label class="text-xl block font-semibold ml-2">Divers </label>
        </div>
        <div class="flex justify-between items-center pt-6 flex-wrap">
          <v-switch
            v-model="repChoice"
            label="Toujours afficher les propositions multichoix sous forme de texte"
            hide-details
          ></v-switch>
        </div>
      </div>
      <!-- Actions -->
      <div class="flex justify-between items-center pt-6 flex-wrap">
        <v-btn prepend-icon="mdi-trash-can" class="bg-second text-white mb-6" outlined @click="deleteAccount">
          Supprimer mon compte
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script setup>
  import {ref, computed, onMounted} from "vue";
  import {VDateInput} from "vuetify/labs/VDateInput";

  const pseudo = ref("");
  const email = ref("");
  const editingPseudo = ref(false);
  const newPseudo = ref("");
  const pwdForPseudo = ref("");

  const repChoice = ref(false);

  const editingEmail = ref(false);
  const newEmail = ref("");
  const pwdForEmail = ref("");

  const editingMdp = ref(false);
  const newMdp = ref("");
  const confirmMdp = ref("");
  const pwdForMdp = ref("");

  const animePrivacy = ref("public");
  const malUsername = ref("");
  const dob = ref(null);

  const genders = [
    {title: "Homme", value: "male"},
    {title: "Femme", value: "female"},
    {title: "Non répertorié", value: "other"},
  ];
  const gender = ref(null);

  const countries = ["France", "Canada"];
  const country = ref(null);

  // calcul de l'âge
  const age = computed(() => {
    if (!dob.value) return 0;
    const diff = Date.now() - new Date(dob.value).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  });

  const showKids = ref(false);
  const showNSFW = ref(false);

  // filtres de chansons
  const filters = ref({
    enCours: false,
    aVoir: false,
    termine: false,
    enPause: false,
    abandonne: false,
    fav: false,
  });
  onMounted(() => {
    document.getElementById("logo").classList.remove("active");
  });
  function toggleNSFW() {
    if (age.value >= 18) {
      showNSFW.value = !showNSFW.value;
    } else {
      showNSFW.value = false;
    }
  }
  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mois = 0-11
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function dobUpdate() {
    console.log(formatDateToYYYYMMDD(dob.value));
  }

  function importMAL() {
    // placeholder pour appel API
    alert(`Import depuis MAL pour ${malUsername.value}`);
  }

  // placeholder pour envoi des données
  console.log({
    pseudo: pseudo.value,
    email: email.value,
    animePrivacy: animePrivacy.value,
    malUsername: malUsername.value,
    dob: dob.value,
    gender: gender.value,
    country: country.value,
    showNSFW: showNSFW.value,
    filters: filters.value,
  });

  function savePseudo() {
    // TODO: appel API
    console.log({newPseudo: newPseudo.value});
    editingPseudo.value = false;
  }
  function saveEmail() {
    // TODO: appel API
    console.log({newEmail: newEmail.value});
    editingEmail.value = false;
  }
  function saveMdp() {
    // TODO: appel API
    console.log({newMdp: newMdp.value});
    editingMdp.value = false;
  }
  function deleteAccount() {
    if (confirm("Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.")) {
      // placeholder suppression
      alert("Compte supprimé.");
    }
  }
</script>

<style scoped>
  /* si besoin de styles CSS supplémentaires */
</style>
